import React, { Component } from 'react';
import styles from './List.module.css';
import { Button } from 'reactstrap';
import { restructureResponse } from '../../helpers/sparql';


class List extends Component {
  render() {
    if (!this.props.data) return null;
    let key = this.props.data.head.vars[0];
    let publishVariable = this.props.publishVariable;
    let items = restructureResponse(this.props.data)

    return (
      <ul className={styles.main}>
        {items.map((item, index) => {
          if (publishVariable) {
            return (
              <li key={index}>
                <Button color="link" style={{ padding: '0px' }} onClick={() => this.props.publish(publishVariable, item[publishVariable])}>
                  {item[key]}
                </Button>
              </li>
            );
          } else {
            return (
              <li key={index}>
                <div style={{ padding: '2px 1px 1px' }}>{item[key]}</div>
              </li>
            );
          }
        })}
      </ul>
    );
  }
}

export default List;
